import React, { useState, useEffect, startTransition } from 'react';
import './App.css';
import ReactPlayer from 'react-player';
import MaleAvatar from './MaleAvatar';
import FemaleAvatar from './FemaleAvatar';

const App = () => {
  const [activeTab, setActiveTab] = useState('SignTranslation');
  const [activeRightTab, setActiveRightTab] = useState('Stickman');
  const [inputText, setInputText] = useState("");
  const [translatedText, setTranslatedText] = useState("");
  const [loading, setLoading] = useState(false); // State to track loading status
  const [showTranslationBox, setShowTranslationBox] = useState(false); // State to control visibility of the translation box
  const [videoSources, setVideoSources] = useState([]); // Array to store video sources
  const [currentVideoIndex, setCurrentVideoIndex] = useState(0); // Track current video index

  const handleTyping = (event) => {
    const text = event.target.value;
    setInputText(text);
  };
   
  const handleVideoEnded = () => {
    if (currentVideoIndex < videoSources.length - 1) {
      const nextVideoIndex = currentVideoIndex + 1;
      const nextVideo = document.createElement('video'); // Create a new video element
      nextVideo.src = videoSources[nextVideoIndex];
      nextVideo.oncanplaythrough = () => {
        setCurrentVideoIndex(nextVideoIndex);
      };
      nextVideo.load(); // Preload the next video
    }
  };
  
  
  useEffect(() => {
    if (videoSources.length > 0) {
      // Preload all videos
      videoSources.forEach(src => {
        const video = document.createElement('video');
        video.src = src;
        video.preload = 'auto';
      });
    }
  }, [videoSources]);
  

  
  const handleengstickGenerateClick = () => {
    setLoading(true); // Start loading
    fetch("https://EzekielMW-test3.hf.space/translate", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        text: inputText,
        source_language: 'eng',
        target_language: 'ksl',
      }),
    })
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return response.json();
    })
    .then(data => {
      const translatedText = data.translation;
      setTranslatedText(translatedText); // Set the translated text
      setShowTranslationBox(true); // Show the translation box
      setLoading(false); // Stop loading
  
      // Generate video sources based on the translated text
      const words = translatedText.trim().toUpperCase().split(/\s+/);
      const videoPaths = words.map(word => `SignVids/stickmans/${word}.mp4`);
      setVideoSources(videoPaths);
      setCurrentVideoIndex(0);
  
      // Automatically switch to the Stickman tab and play the first video
      setActiveRightTab('Stickman');
    })
    .catch(error => {
      console.error('Error:', error);
      setLoading(false); // Stop loading on error
    });
  };
  

  useEffect(() => {
    if (videoSources.length > 0 && currentVideoIndex < videoSources.length) {
      console.log(`Playing video: ${videoSources[currentVideoIndex]}`);
    }
  }, [currentVideoIndex, videoSources]); 

 
  const handlekisGenerateClick = () => {
    setLoading(true); // Start loading
    fetch("https://EzekielMW-test3.hf.space/translate", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        text: inputText,
        source_language: 'swa', // Changed to 'eng' as per your curl request
        target_language: 'ksl',
      }),
    })
      .then(response => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.json();
      })
      .then(data => {
        const translatedText = data.translation;
        setTranslatedText(translatedText); // Set the translated text
        setActiveRightTab('KSL');
        setShowTranslationBox(true); // Show the translation box
        setLoading(false); // Stop loading
      })
      .catch(error => {
        console.error('Error:', error);
        setLoading(false); // Stop loading on error
      });
  };
  

  const handleengGenerateClick = () => {
    setLoading(true); // Start loading
    fetch("https://EzekielMW-test3.hf.space/translate", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        text: inputText,
        source_language: 'eng',
        target_language: 'ksl',
      }),
    })
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return response.json();
    })
    .then(data => {
      const translatedText = data.translation;
      setTranslatedText(translatedText); // Set the translated text
      setActiveRightTab('KSL');
      setShowTranslationBox(true); // Show the translation box
      setLoading(false); // Stop loading
    })
    .catch(error => {
      console.error('Error:', error);
      setLoading(false); // Stop loading on error
    });
  };
  
  const handlekisengGenerateClick = () => {
    setLoading(true); // Start loading
    fetch("https://EzekielMW-test3.hf.space/translate", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        text: inputText,
        source_language: 'swa',
        target_language: 'eng',
      }),
    })
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return response.json();
    })
    .then(data => {
      const translatedText = data.translation;
      setTranslatedText(translatedText); // Set the translated text
      setActiveRightTab('Eng-Ksw');
      setShowTranslationBox(true); // Show the translation box
      setLoading(false); // Stop loading
    })
    .catch(error => {
      console.error('Error:', error);
      setLoading(false); // Stop loading on error
    });
  };
  
  const handleengkisGenerateClick = () => {
    setLoading(true); // Start loading
    fetch("https://EzekielMW-test3.hf.space/translate", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        text: inputText,
        source_language: 'eng',
        target_language: 'swa',
      }),
    })
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return response.json();
    })
    .then(data => {
      const translatedText = data.translation;
      setTranslatedText(translatedText); // Set the translated text
      setActiveRightTab('Eng-Ksw');
      setShowTranslationBox(true); // Show the translation box
      setLoading(false); // Stop loading
    })
    .catch(error => {
      console.error('Error:', error);
      setLoading(false); // Stop loading on error
    });
  };
  
  const handlekslengGenerateClick = () => {
    setLoading(true); // Start loading
    fetch("https://EzekielMW-test3.hf.space/translate", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        text: inputText,
        source_language: 'ksl',
        target_language: 'eng',
      }),
    })
      .then(response => response.json())
      .then(data => {
        const translatedText = data.translation;
        setTranslatedText(translatedText); // Set the translated text
        setActiveRightTab('Eng-Ksw');
        setShowTranslationBox(true); // Show the translation box
        setLoading(false); // Stop loading
      })
      .catch(error => {
        console.error('Error:', error);
        setLoading(false); // Stop loading on error
      });
  };
  
  const handlekslkisGenerateClick = () => {
    setLoading(true); // Start loading
    fetch("https://EzekielMW-test3.hf.space/translate", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        text: inputText,
        source_language: 'ksl',
        target_language: 'swa',
      }),
    })
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return response.json();
    })
    .then(data => {
      const translatedText = data.translation;
      setTranslatedText(translatedText); // Set the translated text
      setActiveRightTab('Eng-Ksw');
      setShowTranslationBox(true); // Show the translation box
      setLoading(false); // Stop loading
    })
    .catch(error => {
      console.error('Error:', error);
      setLoading(false); // Stop loading on error
    });
  };
  
  

  const handleLeftTabClick = (tab) => {
    setActiveTab(tab);
    setShowTranslationBox(false); // Hide the translation box when switching tabs
    if (tab === 'SignTranslation') {
      setActiveRightTab('Stickman');
    } else if ([ 'KSLToEng', 'KSLToKisw', 'EngToKisw', 'KiswToEng'].includes(tab)) {
      setActiveRightTab('Eng-Ksw'); // Make Eng-Ksw active on the right panel
    } else {
      setActiveRightTab('KSL');
    }
  };

 

  const handleRightTabClick = (tab) => {
    startTransition(() => { // Wrap the state update with startTransition
      setActiveRightTab(tab); // Correctly set the active tab on the right panel
      setShowTranslationBox(false); // Hide the translation box when switching tabs
      setInputText(''); // Clear the input text when switching tabs
      setTranslatedText(''); // Clear the translated text when switching tabs

      if (tab === 'Stickman') {
        setActiveTab('SignTranslation'); // Set the left panel to 'SignTranslation' when 'Stickman' is clicked
      } else if (tab === 'KSL') {
        setActiveTab('EngToKSL'); // Set the left panel to 'EngToKSL' when 'KSL' is clicked
      } else if (tab === 'Eng-Ksw') {
        setActiveTab('EngToKisw'); // Set the left panel to 'EngToKisw' when 'Eng-Ksw' is clicked
      } else {
        setActiveTab('SignTranslation'); // Default to 'SignTranslation'
      }
    });
  };

  const getPlaceholderText = () => {
    switch (activeTab) {
      case 'EngToKSL':
        return 'Enter text here...';
      case 'KiswahiliToKSL':
        return 'Weka Maandishi hapa';
      case 'EngToKisw':
        return 'Enter text here...';
      case 'KiswToEng':
        return 'Weka Maandishi hapa';
      case 'KSLToEng':
      case 'KSLToKisw':
        return 'Enter KSL text here...';
      default:
        return 'Enter text here...';
    }
  };

  const getTranslationPlaceholder = () => {
    switch (activeRightTab) {
      case 'KSL':
        return activeTab === 'KiswahiliToKSL' || activeTab === 'EngToKSL' ? 'Translation will appear here...' : 'Tafsiri itaonekana hapa...' ;
      case 'Eng-Ksw':
        return activeTab === 'EngToKisw' || activeTab === 'KSLToKisw'
          ? 'Tafsiri itaonekana hapa...'
          : 'Translation will appear here...';
      default:
        return 'Translation will appear here...';
    }
  };
  
  
  return (
    <div className="app">
      <header className="app-header">
        <h1>MULTILINGUAL TRANSLATOR FOR KENYAN SIGN LANGUAGE (KSL), ENGLISH AND KISWAHILI</h1>
        
      </header>
      <div className="app-content">
        <div className="left-panel">
          <div className="tabs">
          <button 
              className={`tab-button ${activeTab === 'SignTranslation' ? 'active' : ''}`} 
              onClick={() => handleLeftTabClick('SignTranslation')}
            >
              Sign Translation
            </button>
            <button 
              className={`tab-button ${activeTab === 'EngToKSL' ? 'active' : ''}`} 
              onClick={() => handleLeftTabClick('EngToKSL')}
            >
              English To KSL
            </button>
            <button 
              className={`tab-button ${activeTab === 'KiswahiliToKSL' ? 'active' : ''}`} 
              onClick={() => handleLeftTabClick('KiswahiliToKSL')}
            >
              Kiswahili To KSL
            </button>
          </div>
          <div className="tabs">
            <button 
              className={`tab-button ${activeTab === 'KSLToEng' ? 'active' : ''}`} 
              onClick={() => handleLeftTabClick('KSLToEng')}
            >
              KSL To English
            </button>
            <button 
              className={`tab-button ${activeTab === 'KSLToKisw' ? 'active' : ''}`} 
              onClick={() => handleLeftTabClick('KSLToKisw')}
            >
              KSL to Kiswahili
            </button>
            <button 
              className={`tab-button ${activeTab === 'EngToKisw' ? 'active' : ''}`} 
              onClick={() => handleLeftTabClick('EngToKisw')}
            >
              Eng To Kisw
            </button>
            <button 
              className={`tab-button ${activeTab === 'KiswToEng' ? 'active' : ''}`} 
              onClick={() => handleLeftTabClick('KiswToEng')}
            >
              Kisw To Eng
            </button>
          </div>
          {activeTab === 'SignTranslation' && (
  <>
    <textarea 
      className="text-input" 
      placeholder={getPlaceholderText()} 
      onChange={handleTyping} 
      value={inputText} // Bind input text to state
    />
    <button onClick={handleengstickGenerateClick} className="generate-button">
      Generate
    </button>
    {showTranslationBox && ( // Only show this textarea if generate has been clicked
      <textarea 
        className="text-output" 
        placeholder={getTranslationPlaceholder()} 
        value={translatedText} // Show the translated text
        readOnly // Make the output text box read-only
      />
    )}
  </>
)}


          {activeTab === 'EngToKSL' && (
            <>
              <textarea 
                className="text-input" 
                placeholder={getPlaceholderText()}
                onChange={handleTyping} 
                value={inputText} 
              />
              <button onClick={handleengGenerateClick} className="generate-button">
                Generate
              </button>
            </>
          )}

          {activeTab === 'KiswahiliToKSL' && (
            <>
              <textarea 
                className="text-input" 
                placeholder={getPlaceholderText()}
                onChange={handleTyping} 
                value={inputText} 
              />
              <button onClick={handlekisGenerateClick} className="generate-button">
                Generate
              </button>
            </>
          )}

          {activeTab === 'KSLToEng' && (
            <>
              <textarea 
                className="text-input" 
                placeholder={getPlaceholderText()} 
                onChange={handleTyping} 
                value={inputText} 
              />
              <button onClick={handlekslengGenerateClick} className="generate-button">
                Generate
              </button>
            </>
          )}

          {activeTab === 'KSLToKisw' && (
            <>
              <textarea 
                className="text-input" 
                placeholder={getPlaceholderText()} 
                onChange={handleTyping} 
                value={inputText} 
              />
              <button onClick={handlekslkisGenerateClick} className="generate-button">
                Generate
              </button>
            </>
          )}

          {activeTab === 'EngToKisw' && (
            <>
              <textarea 
                className="text-input" 
                placeholder={getPlaceholderText()}
                onChange={handleTyping} 
                value={inputText} 
              />
              <button onClick={handleengkisGenerateClick} className="generate-button">
                Generate
              </button>
            </>
          )}

          {activeTab === 'KiswToEng' && (
            <>
              <textarea 
                className="text-input" 
                placeholder={getPlaceholderText()}
                onChange={handleTyping} 
                value={inputText} 
              />
              <button onClick={handlekisengGenerateClick} className="generate-button">
                Generate
              </button>
            </>
          )}
        </div>
        <div className="right-panel">
          <div className="tabs">
          <button 
              className={`tab-button ${activeRightTab === 'Stickman' ? 'active' : ''}`} 
              onClick={() => handleRightTabClick('Stickman')}
            >
              Stickman
            </button>
            <button 
              className={`tab-button ${activeRightTab === 'KSL' ? 'active' : ''}`} 
              onClick={() => handleRightTabClick('KSL')}
            >
              KSL
            </button>
            <button 
              className={`tab-button ${activeRightTab === 'Eng-Ksw' ? 'active' : ''}`} 
              onClick={() => handleRightTabClick('Eng-Ksw')}
            >
              Eng-Ksw
            </button>
            <button 
              className={`tab-button ${activeRightTab === 'MaleAvatar' ? 'active' : ''}`} 
              onClick={() => handleRightTabClick('MaleAvatar')}
            >
              Male Avatar
            </button>
            <button 
              className={`tab-button ${activeRightTab === 'FemaleAvatar' ? 'active' : ''}`} 
              onClick={() => handleRightTabClick('FemaleAvatar')}
            >
              Female Avatar
            </button>
          </div>
          <div className="visualization-container"> 
            {loading ? (
              <div className="loading-dots">
                <div></div><div></div><div></div>
              </div>
            ) : (
              <>
                {activeRightTab === 'Stickman' && videoSources.length > 0 && (
                  <ReactPlayer 
                    url={videoSources[currentVideoIndex]} 
                    playing 
                    onEnded={handleVideoEnded}
                    controls={false}
                    width="100%"
                    height="100%"
                  />
                )}

                {activeRightTab === 'KSL' && (
                  <div className="ksl-text">
                    {translatedText ? translatedText : getTranslationPlaceholder()}
                  </div>
                )}
                {activeRightTab === 'Eng-Ksw' && (
                  <div className="ksl-text">
                    {translatedText ? translatedText : getTranslationPlaceholder()}
                  </div>
                )}
                {activeRightTab === 'MaleAvatar' && (
                  <MaleAvatar /> 
                )}
                {activeRightTab === 'FemaleAvatar' && (
                  <FemaleAvatar /> 
                )}
              </>
            )}
          </div>
        </div>
      </div>
      <footer className="app-footer">
        <p>Powered by AI4KSL</p>
      </footer>
    </div>
  );
}

export default App;
